import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { ThemeService } from '../../_core/services/theme.service';
import { Subject, takeUntil } from 'rxjs';
import { UserService } from '../../_core/services/user.service';
import { ToastService } from '../../_core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-verify-otp-popup',
  standalone: true,
  templateUrl: './verify-otp-popup.component.html',
  styleUrls: ['./verify-otp-popup.component.scss'],
  imports: [IonicModule, CommonModule, ReactiveFormsModule]
})
export class VerifyOtpPopupComponent implements OnInit {

  @Input() email!: string;
  @Input() phone!: string;
  logo!: string;
  isDarkMode!: boolean;
  private readonly destroy$: Subject<void> = new Subject();

  form: FormGroup;
  isVerifying = false; 
  isResending = false; 

  constructor(
    private fb: FormBuilder,
    private modalCtrl: ModalController,
    private themeService: ThemeService,
    private userService: UserService,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {
    this.form = this.fb.group({
      code: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.isDarkMode = this.themeService.isDarkMode;
    this.logo = this.isDarkMode ? '/assets/img/logo-60-darkmode.png' : '/assets/img/logo-60.png';

    this.themeService
      .subscribeThemeUpdate()
      .pipe(takeUntil(this.destroy$))
      .subscribe((isDark) => {
        this.logo = isDark ? '/assets/img/logo-60-darkmode.png' : '/assets/img/logo-60.png';
      });
  }

  dismiss() {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  async verify() {
    if (this.form.valid) {
      this.isVerifying = true;
      setTimeout(() => {
        this.isVerifying = false;
        this.modalCtrl.dismiss({ success: true, code: this.form.value.code });
      }, 1500);
    }
  }

  async resendOTP() {
    if (!this.email || !this.phone) return;

    try {
      this.isResending = true;
      const success = await this.userService.sendOTPEmail(this.email, this.phone).toPromise();
      if (success) {
        this.toastService.presentToast(this.translateService.instant('OTP resent successfully'));
      } else {
        this.toastService.presentDangerToast(this.translateService.instant('Failed to resend OTP'));
      }
    } catch (err) {
      this.toastService.presentDangerToast(this.translateService.instant('Error sending OTP'));
      console.error(err);
    } finally {
      this.isResending = false;
    }
  }

}